module.exports = __webpack_public_path__ + "static/media/IMG_1065.c76314ee.png";